__webpack_require__.p = "/BotFramework-WebChat/06.recomposing-ui/e.intelequia/";